import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { FicheMiseEnPlace } from "src/app/core/services/business/model/fiche-mise-en-place";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { Request } from "src/app/parametrage/core/model/request";
import { Condition } from "src/app/corporate/core/model/condition";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { TaskDocument } from "src/app/parametrage/core/model/task-document";
import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { ConditionService } from "src/app/corporate/core/service/condition.service";
import { FormAddConditionComponent } from "../../modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "../../modal/form-edit-condition/form-edit-condition.component";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import { FicheMiseEnPlaceService } from "src/app/core/services/business/service/fiche-mise-en-place.service";
import { EditCreditModalComponent } from "../../modal/edit-credit-modal/edit-credit-modal.component";
import { ReportingCorporateService } from "src/app/reporting/core/service/reporting-corporate.service";
import { ReportViewerModalComponent } from "src/app/formulaire/modal/viewer/report-viewer-modal/report-viewer-modal.component";
import { Control } from "src/app/core/services/business/model/control";
import { ControlByRequest } from "src/app/core/services/business/model/control-by-request";
import { ControlService } from "src/app/core/services/business/service/control.service";
import { ControlByRequestService } from "src/app/core/services/business/service/control-by-request.service";
import { AddControlByRequestComponent } from "src/app/formulaire/modal/control-by-request/add-control-by-request/add-control-by-request.component";
import { EditControlByRequestComponent } from "src/app/formulaire/modal/control-by-request/edit-control-by-request/edit-control-by-request.component";
import { TaskDocumentService } from "src/app/parametrage/core/service/task-document.service";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { UploadInRapportComponent } from "src/app/formulaire/modal/upload-in-rapport/upload-in-rapport.component";
import { DocViewerModalComponent } from "src/app/formulaire/modal/viewer/doc-viewer-modal/doc-viewer-modal.component";
import { ImageViewerModalComponent } from "src/app/formulaire/modal/viewer/image-viewer-modal/image-viewer-modal.component";
import { PdfViewerModalComponent } from "src/app/formulaire/modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component";
import { OfficeViewerModalComponent } from "src/app/formulaire/modal/viewer/office-viewer-modal/office-viewer-modal.component";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { RemplacerFichierComponent } from "src/app/formulaire/modal/remplacer-fichier/remplacer-fichier.component";
import { RenommerFichierComponent } from "src/app/formulaire/modal/renommer-fichier/renommer-fichier.component";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-form-generation-fiche-mise-en-place",
  templateUrl: "./form-generation-fiche-mise-en-place.component.html",
  styleUrls: ["./form-generation-fiche-mise-en-place.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class FormGenerationFicheMiseEnPlaceComponent implements OnInit {
  alerts: Alert[] = [];

  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  ficheMiseEnPlace: FicheMiseEnPlace;
  corporate: Corporate;
  request: Request;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  conditions: Condition[];
  conditionArray: Array<Condition[]> = [];
  items: RequestItem[];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  documents: TaskDocument[];
  documentsObligatoire: TaskDocument[];
  fichiers: SubItemCheckedDTO[];

  controls: Control[];
  controlByRequests: ControlByRequest[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private _requestItemService: RequestItemService,
    private _conditionService: ConditionService,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _ficheMiseEnPlaceService: FicheMiseEnPlaceService,
    private _reportingCorporateService: ReportingCorporateService,
    private _controlService: ControlService,
    private _controlByRequestService: ControlByRequestService,
    private _taskDocumentService: TaskDocumentService,
    private _gestionFichierService: GestionFichierService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      nomClient: [null, Validators.compose([Validators.required])],
      numCompteClient: [null, Validators.compose([Validators.required])],
      gestionnaire: [null, Validators.compose([Validators.required])],
      numDossier: [null, Validators.compose([Validators.required])],
      niveauApprobation: [null, Validators.compose([Validators.required])],
      dateApprobation: [null, Validators.compose([Validators.required])],
      dateMiseEnPlace: [null, Validators.compose([Validators.required])],

      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getFicheMiseEnPlaceByrequestId(this.requestId);
      this.getListRequestItemByRequest(this.requestId);
      this.getDynamicControlsByRequestId(this.requestId);
      this.getControlsByRequestByRequestId(this.requestId);
      this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }

  getListRequestItemByRequest(requestId) {
    this._requestItemService.getListRequestItemByRequest(requestId).subscribe(
      (data) => {
        this.items = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateCredit(requestItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;
    modalRef.componentInstance.workflowCode =
      this.checkFormDTO.request.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListRequestItemByRequest(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionsByRequestItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteCondition(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getFicheMiseEnPlaceByrequestId(requestId) {
    this._ficheMiseEnPlaceService
      .getFicheMiseEnPlaceByrequestId(requestId)
      .subscribe(
        (data) => {
          this.ficheMiseEnPlace = data;

          this.getRequestById(this.requestId);
          this.getCorporateByRequestId(this.requestId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;

        if (this.ficheMiseEnPlace.numDossier == null) {
          this.form.controls["numDossier"].setValue(" ");
        }
        if (this.ficheMiseEnPlace.gestionnaire == null) {
          this.form.controls["gestionnaire"].setValue(
            this.request.employee.firstname +
              " " +
              this.request.employee.lastname
          );
        }
        if (this.ficheMiseEnPlace.niveauApprobation == null) {
          this.form.controls["niveauApprobation"].setValue(
            "Comité Interne de Crédit"
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCorporateByRequestId(requestId) {
    this._corporateService.getCorporateByRequestId(requestId).subscribe(
      (data) => {
        this.corporate = data;
        if (this.ficheMiseEnPlace.nomClient == null) {
          this.form.controls["nomClient"].setValue(
            this.corporate.customer.name
          );
        }
        if (this.ficheMiseEnPlace.numCompteClient == null) {
          this.form.controls["numCompteClient"].setValue(
            this.corporate.accountNumber
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDynamicControlsByRequestId(requestid) {
    this._controlService.getDynamicControlsByRequestId(requestid).subscribe(
      (data) => {
        this.controls = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getControlsByRequestByRequestId(requestid) {
    this._controlByRequestService
      .getControlByRequestsByRequestId(requestid)
      .subscribe(
        (data) => {
          this.controlByRequests = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  addControlByRequest(controlId): void {
    const modalRef = this.modalService.open(AddControlByRequestComponent, {
      centered: true,
    });

    modalRef.componentInstance.controlId = controlId;
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getDynamicControlsByRequestId(this.requestId);
        this.getControlsByRequestByRequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  editControlByRequest(controlByRequestId): void {
    const modalRef = this.modalService.open(EditControlByRequestComponent, {
      centered: true,
    });

    modalRef.componentInstance.controlByRequestId = controlByRequestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getDynamicControlsByRequestId(this.requestId);
        this.getControlsByRequestByRequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  putFicheMiseEnPlace(): void {
    this.alerts = [];
    this._ficheMiseEnPlaceService
      .putFicheMiseEnPlace(this.ficheMiseEnPlace)
      .pipe(first())
      .subscribe(
        (data) => {
          this.alerts.push({
            type: "success",
            message: "Les modifications ont été enregistrées",
          });
        },
        (error) => {
          console.log(error);

          this.alerts.push({
            type: "danger",
            message: "Les modifications n'ont pas été enregistrées",
          });
        }
      );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  Apercu() {
    this._reportingCorporateService
      .ficheMisEnPlace(this.requestId)
      .subscribe((blob) => {
        const modalRef = this.modalService.open(ReportViewerModalComponent, {
          size: "lg",
          backdrop: "static",
          centered: true,
        });

        modalRef.componentInstance.destination = blob;

        modalRef.result.then(
          (data) => {},
          (reason) => {}
        );
      });
  }

  downloadFiche(exportType) {
    this._reportingCorporateService
      .ficheMisEnPlace(this.requestId)
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileUrl;

        if (exportType == "PDF") {
          link.setAttribute("download", "fiche_mis_en_place.pdf");
        } else {
          link.setAttribute("download", "fiche_mis_en_place.docx");
        }

        document.body.appendChild(link);
        link.click();
      });
  }

  getRapportsClient(requestId, filenameWithoutExtension) {
    this._gestionFichierService
      .getRapportsClient(requestId, filenameWithoutExtension)
      .subscribe(
        (data) => {
          this.fichiers = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getTaskDocumentsNotUploadedByTaskId(taskId) {
    this._taskDocumentService
      .getTaskDocumentsNotUploadedByTaskId(taskId)
      .subscribe(
        (data) => {
          this.documents = data.sort((a, b) => (a.label > b.label ? 1 : -1));
          this.documentsObligatoire = this.documents.filter(
            (t) => t.obligatoire == true
          );
          if (this.documents.length == 1) {
            this.getRapportsClient(this.requestId, this.documents[0].code);
          } else {
            this.getRapportsClient(this.requestId, "_");
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInRapportComponent, {
      centered: true,
    });

    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        // on close
        this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  remplacerFichier(subitemId, name, displayname) {
    const modalRef = this.modalService.open(RemplacerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.codeDocument = name.split(".")[0];
    modalRef.componentInstance.displayname = displayname;

    modalRef.result.then(
      (data) => {
        // on close
        this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  renommerFichier(subitemId) {
    const modalRef = this.modalService.open(RenommerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteFile(subItemId) {
    if (confirm("Press a button!")) {
      this._gestionFichierService.delete(subItemId).subscribe(
        (data) => {
          this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  /** */

  fileViewer(subitem: SubItem): void {
    const fileTab = subitem.name.split(".");
    const fileExtension = fileTab[fileTab.length - 1];

    if (fileExtension.toLowerCase() == "pdf") {
      this.pdfViewer(subitem.id);
    } else if (
      fileExtension.toLowerCase() == "png" ||
      fileExtension.toLowerCase() == "jpeg" ||
      fileExtension.toLowerCase() == "jpg"
    ) {
      this.imageViewer(subitem.id);
    } else {
      this.officeViewer(subitem.id);
    }
  }

  officeViewer(subitemId): void {
    const modalRef = this.modalService.open(OfficeViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  imageViewer(subitemId): void {
    const modalRef = this.modalService.open(ImageViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  docViewer(subitemId): void {
    const modalRef = this.modalService.open(DocViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
